import { render, staticRenderFns } from "./ConsignacaoParcelas.vue?vue&type=template&id=328768e7&"
import script from "./ConsignacaoParcelas.vue?vue&type=script&lang=js&"
export * from "./ConsignacaoParcelas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports